(function () {
  function initHero() {
    if (typeof Swiper === 'undefined') {
      return window.setTimeout(initHero, 50);
    }

    document.querySelectorAll('.ctr-hero__carousel').forEach(function (carousel) {
      if (carousel.dataset.ctrInit) return;
      carousel.dataset.ctrInit = '1';

      var hero = carousel.closest('.ctr-hero');
      var dots = hero ? hero.querySelector('.ctr-hero__dots') : null;
      var slideCount = carousel.querySelectorAll('.swiper-slide').length;

      new Swiper(carousel, {
        slidesPerView: 1,
        loop: slideCount > 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: slideCount > 1 ? { delay: 5000, disableOnInteraction: false } : false,
        pagination: dots ? { el: dots, clickable: true } : false
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHero);
  } else {
    initHero();
  }
})();
